import styled from 'styled-components';
import { StyleColor, navBarHeight } from '../../../utils/styles-constants';

export const StyledTheaterHeader = styled('div')`
	display: flex;
	height: ${navBarHeight};
	box-sizing: border-box;
	color: ${StyleColor.White};
	width: 100%;
	align-items: center;
	flex-direction: row;
	padding: 0 10px;
`;

export const LeftBlock = styled('div')`
	text-align: left;
	flex-basis: 33.3%;
`;

export const CenterBlock = styled('div')`
	text-align: center;
	font-size: 16px;
	font-weight: 500;
	flex-basis: 33.3%;
`;

export const RightBlock = styled('div')`
	flex-basis: 33.3%;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	& svg {
		fill: ${StyleColor.White};
	}
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Header/styles.ts